import { AssetType, type SaleAssetBusEntity } from '~/apiClient';
import type { PlatformSaleItemEntity } from '~/types/sale.type';

export type UseXdpSeoMetaReturnType = void;

export const useSdpSeoMeta = (sale: Ref<PlatformSaleItemEntity>): UseXdpSeoMetaReturnType => {
    const { tt, td, formatUnits } = useTypedI18n();
    const image = useImage();

    const mainAsset = computed<SaleAssetBusEntity | undefined>(() => sale.value?.mainAsset);
    const assetType = computed<AssetType>(() => mainAsset.value?.assetType || AssetType.Bus);

    useSeoMeta({
        title: () =>
            tt('seo.sdp.title', {
                asset: tt(`asset.type.${assetType.value}`, 1), // Single form in ADP
                brand: mainAsset.value?.brand.brandValue,
                model: mainAsset.value?.model.modelValue,
                vin: mainAsset.value?.vin,
            }),
        ogTitle: tt('seo.sdp.ogTitle', {
            asset: tt(`asset.type.${assetType.value}`, 1),
            brand: mainAsset.value?.brand.brandValue,
            model: mainAsset.value?.model.modelValue,
        }),
        ...setIf(!!sale.value, () => ({
            description: tt(`seo.sdp.${sale.value.sellingMethod}.description`, {
                asset: tt(`asset.type.${assetType.value}`, 1),
                brand: mainAsset.value?.brand.brandValue,
                model: mainAsset.value?.model.modelValue,
                vin: mainAsset.value?.vin,
            }),
            ogDescription: tt(`seo.sdp.${sale.value.sellingMethod}.ogDescription`, {
                asset: tt(`asset.type.${assetType.value}`, 1),
                brand: mainAsset.value?.brand.brandValue,
                model: mainAsset.value?.model.modelValue,
                year: td(mainAsset.value?.firstRegistration!, 'mmyyyyUTC'),
                euroNorm: tt(`asset.euroNorm.${mainAsset.value?.euroNorm!}`),
                kilometers: formatUnits.km(mainAsset.value?.km!),
            }),
        })),
        ...(mainAsset.value?.images.cover[0] && {
            ogImage: {
                url: image(mainAsset.value.images.cover[0], { width: 1280, height: 960 }),
                width: '1280px',
                height: '960px',
                alt: `Fleequid ${mainAsset.value.brand.brandValue} ${mainAsset.value.model.modelValue} ${mainAsset.value.vin}`,
            },
        }),
    });
};
